/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Bold_TooltipInputs */



/**
* | output |
* | --- |
* | "Check for Events where all lines are bolded" |
*
* @param {Style_Guide_Manager_Bold_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_bold_tooltip = /** @type {((inputs?: Style_Guide_Manager_Bold_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Bold_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verifier les evenements ou toutes les lignes sont en gras")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie die Ereignisse, bei denen alle Zeilen fett gedruckt sind.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlla gli eventi in cui tutte le linee sono in grassetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Найдите события, где все строки выделены жирным шрифтом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobar eventos donde todas las líneas estén en negrita")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查所有线条都加粗的事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての行が太字になっているイベントを確認します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन इवेंट्स की जाँच करें जहाँ सभी लाइनें बोल्ड की गई हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique os eventos em que todas as linhas estão em negrito.")
	return /** @type {LocalizedString} */ ("Check for Events where all lines are bolded")
});